import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SubscriptionTemplateLinkCreateInput } from '../generated/globalTypes';
import { createSubscriptionTemplateLinkMutation, createSubscriptionTemplateLinkMutationVariables } from '../generated/createSubscriptionTemplateLinkMutation';
import { subscriptionTemplateLinkFieldsFragment } from '../models/SubscriptionTemplateLink';

/**
 * Get a callback to create a SubscriptionTemplateLink in the store.
 */
export function useCreateSubscriptionTemplateLinkCallback(): [(model: SubscriptionTemplateLinkCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createSubscriptionTemplateLinkMutation, createSubscriptionTemplateLinkMutationVariables>(
        gql`
            mutation createSubscriptionTemplateLinkMutation ($model: SubscriptionTemplateLinkCreateInput!) {
                createSubscriptionTemplateLink(model: $model) {
                    ...subscriptionTemplateLinkFields
                }
            }

            ${subscriptionTemplateLinkFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: SubscriptionTemplateLinkCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
